import { render, staticRenderFns } from "./LimitsForm.vue?vue&type=template&id=26a0db3c"
import script from "./LimitsForm.vue?vue&type=script&lang=js"
export * from "./LimitsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports